import { render, staticRenderFns } from "./shortAnswer.vue?vue&type=template&id=4bbd21fa&scoped=true"
import script from "./shortAnswer.vue?vue&type=script&lang=js"
export * from "./shortAnswer.vue?vue&type=script&lang=js"
import style0 from "./shortAnswer.vue?vue&type=style&index=0&id=4bbd21fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd21fa",
  null
  
)

export default component.exports